import { useAtomValue, useSetAtom } from 'jotai';
import { useCallback } from 'react';
import { useTranslation } from 'next-i18next';
import { ArrowPathIcon } from '@heroicons/react/24/outline';

import { Button } from '@restworld/ui-ds-base';

import { jobActiveStatusAtom } from '../job-position/job-position.atoms';
import { offlineJpModalOpenAtom } from './offline-jp.atoms';

// Inline CTA shown directly below the disabled "Candidati" button when the
// JP is offline. The disabled apply button still says "Candidati ora" (with a
// hover popover explaining why), and this button gives the user a clear next
// action: re-open the offline-landing modal where the recovery options live.
//
// We render only when the JP is offline; on active JPs this is a no-op.
export const ReopenTriggerButton = () => {
  const { t } = useTranslation();
  const jobActiveStatus = useAtomValue(jobActiveStatusAtom);
  const setOpen = useSetAtom(offlineJpModalOpenAtom);

  const onClick = useCallback(() => setOpen(true), [setOpen]);

  if (jobActiveStatus) return null;

  return (
    <div className="mt-3 flex flex-col gap-2 p-3 rounded-lg bg-purple-50 border border-purple-100">
      {/* Bold standout line stating *what* happened. Sits on its own row above the
          body copy so the user reads "sospesa, non accetta candidature" before the
          secondary explainer. */}
      <p className="text-sm font-semibold text-gray-900 leading-5">{t('job-position-page:offline_inline_status')}</p>
      <p className="text-sm text-gray-700 leading-5">{t('job-position-page:offline_inline_message')}</p>
      <Button fullwidth size="md" variant="primary" StartIcon={ArrowPathIcon} onClick={onClick}>
        {t('job-position-page:offline_inline_cta')}
      </Button>
    </div>
  );
};
